import { SeoMetaTypeEnum } from '@is24at/react-enums';
import seoRules from 'core/seoRules';

const title = ({ searchQuery }: any) =>
  seoRules.lookupAndFormatFor(SeoMetaTypeEnum.TITLE, searchQuery);

export default title;
